import * as React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { IDebtObligation } from "../../../../model/report/applicantdata/DebtObligation";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const PDFExportDebtObligation = ({
  translate,
  data
}: {
  translate?: any;
  data?: IDebtObligation[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <View>
      <View style={styles.titleCol}>
        <Text style={styles.header}>
          {translate("report8.document_template.debt_obligations.title")}
        </Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.debt_obligations.debtor_name"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.debt_obligations.description"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate("report8.document_template.debt_obligations.creditor")}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={{ ...styles.tableCell, textAlign: "right" }}>
              {translate(
                "report8.document_template.debt_obligations.debt_value"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>
              {translate(
                "report8.document_template.debt_obligations.debt_period"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={{ ...styles.tableCell, textAlign: "right" }}>
              {translate(
                "report8.document_template.debt_obligations.paid_during_last_year"
              )}
            </Text>
          </View>
          <View style={styles.tableCol}>
            <Text style={{ ...styles.tableCell, textAlign: "right" }}>
              {translate(
                "report8.document_template.debt_obligations.left_to_pay"
              )}
            </Text>
          </View>
        </View>
        {data?.map((debt, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{debt.debtorName}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{debt.description}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{debt.creditor}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(debt.debtValue)}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{debt.debtPeriod}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(debt.paidDuringLastYear)}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {NumberFormatter().formatReadOnlyValue(debt.leftToPay)}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PDFExportDebtObligation;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});


const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "10pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "12pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginBottom: 20,
    marginLeft: 5
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "14.28%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  }
});
